<div class="page-layout blank p-24" fusePerfectScrollbar>
	<div class="content fx-row fx-wrap fx-sm-column fx-sm-wrap fx-xs-column fx-xs-wrap" style="gap: 24px">
		<seeding-utility class="fx-flex fx-gt-lg-flex-50"></seeding-utility>
		<cache-utility class="fx-flex fx-gt-lg-flex-50"></cache-utility>
	</div>

	<!--
	<div class="content mt-24 fx-row fx-wrap" style="gap: 24px">
		<import-customers-utility class="fx-flex fx-gt-lg-flex-50"></import-customers-utility>
		<import-suppliers-utility class="fx-flex fx-gt-lg-flex-50"></import-suppliers-utility>
	</div>-->
	<div class="content mt-24 fx-row fx-wrap fx-sm-column fx-sm-wrap fx-xs-column fx-xs-wrap" style="gap: 24px">
		<!--<import-old-statistics-utility class="fx-flex fx-gt-lg-flex-50"></import-old-statistics-utility>-->
		<process-file-utility class="fx-flex fx-gt-lg-flex-50"></process-file-utility>
	</div>
	
</div>
